'use strict';

import React from 'react';
import API from 'sources/API';
import {Link,browserHistory} from 'react-router';
import AlbumActions from 'actions/AlbumActions';

require('styles/AlbumBrief.scss');

class AlbumBriefComponent extends React.Component {
	constructor(props) {
	  super(props);
	  let {album, count, totalPrice, paySignature, isAuthor} = this.props;
	  this.state = {
	      album_id: album._id,
	      album: album,
	      totalPrice: totalPrice,
	      paySignature: paySignature,
	      count: count,
	      isAuthor: isAuthor,
	      alertRevealShow: false
	  }
	  this.albumPay = this.albumPay.bind(this);
	  this.toggleReveal = this.toggleReveal.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		let {album, count, totalPrice, paySignature, isAuthor} = nextProps;
		this.setState({
		album_id: album._id,
			album: album,
			totalPrice: totalPrice,
			paySignature: paySignature,
			count: count,
			isAuthor: isAuthor
		});
	}
	toggleReveal(type) {
		let key = `${type}RevealShow`;
		let newState = {};
		if(this.state[key]) {
			newState[key] = false;
		} else {
			newState[key] = true;
		}
		this.setState(newState);
	}
	albumPay(){
	  let check = API.checkToken;
	  if(check) {
	    if(!API.isWechat) {
	      this.toggleReveal('alert');
	      return;
	    }
		if(this.state.totalPrice === 0){
    	  return;
		}
	    let params = {
	      method: 'POST',
	      headers: API.urlHeader,
	      body: `accessToken=${API.accessToken}&pay_signature=${this.state.paySignature}`
	    };
	    window.ga('send', {
	      hitType: 'event',
	      eventCategory: 'album',
	      eventAction: 'pay',
	      eventLabel: this.state.album_id,
	      eventValue: this.state.totalPrice
	    });

	    var album_id = this.state.album_id;
	    var totalPrice = this.state.totalPrice;

	    fetch(API.postAlbumPay.replace(':id', album_id), params)
	      .then(res=>res.json())
	      .then(json=>{
	        function onBridgeReady(){
	          window.WeixinJSBridge.invoke('getBrandWCPayRequest', json.options, function(res){
	            AlbumActions.fetchAlbumArticleMedia(album_id);
							if(res.err_msg === "get_brand_wcpay_request：ok" || res.err_msg.indexOf("ok") !== -1 ) {			
								browserHistory.push('/result/pay');
	              window.ga('send', {
	                hitType: 'event',
	                eventCategory: 'media',
	                eventAction: 'pay-success',
	                eventLabel: album_id,
	                eventValue: totalPrice
	              });
	            }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
	          });
	        }
	        if (typeof WeixinJSBridge === "undefined"){
	          if( document.addEventListener ){
	            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
	          } else if (document.attachEvent){
	            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
	            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
	          }
	        } else {
	          onBridgeReady();
	        }
	      });
	  }
	}
	render(){
	  let alertReveal;
	  if(this.state.alertRevealShow) {
	    alertReveal = (
	      <div className="reveal-overlay">
	        <div className="reveal">
	        <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'alert')}>
	          <span aria-hidden="true">&times;</span>
	          </button>
	          <p className="mt-30 text-center">请在微信内完成支付。</p>
	        </div>
	      </div>
	    );
		}
		let {name,desc,cover,author,pay_user_amount,view_article} = this.state.album;
		let createMarkup = () =>  {
      return {__html: desc||(this.state.isAuthor?"快去完善专辑介绍吧～～":"如果我们无法探索宇宙，一定要把这颗星球看一看.")};
    }
	  return (
	  	<div className="album-brief-component">
	  	  {alertReveal}
	  	  <div className="album">
					<div className="title">
						{name}
					</div>
					{/* <div className='view-count'>
						阅读量: {(view_article)||0}
					</div> */}
					<div className="separator">
					</div>
					<div className="desc">
						{/* {desc||(this.state.isAuthor?"快去完善专辑介绍吧～～":"如果我们无法探索宇宙，一定要把这颗星球看一看.")} */}
						<pre className="content-intro" dangerouslySetInnerHTML={createMarkup()} />
					</div>
		  	</div>
				<div className="user">
					<div className="separator"></div>
					<div className="nameTag">主编</div>
					<div className="avatar">
						<Link to={`/user/${author?author._id:''}`}><img src={author?author.avatar:"https://img.xiaodiqiu.cn/avatar.jpeg"} /></Link>
					</div>
					<div>
						<Link className="name" to={`/user/${author?author._id:''}`}>{author?author.name:""}</Link>
					</div>
					<div className="slogan">
						{author?(author.slogan||author.summary):""}
					</div>
				</div>
				<div className="price">
					<div className="pay" onClick={this.albumPay}>
						{this.state.totalPrice === 0?(API.accessToken?"已获取":"去登录"):`${this.state.totalPrice}元`}
					</div>
					<div className="state">
						付费获取隐藏信息
					</div>
				</div>
	  	</div>
	  );
	}
}

AlbumBriefComponent.displayName = 'AlbumBriefComponent';

export default AlbumBriefComponent;



// WEBPACK FOOTER //
// ./src/components/AlbumBriefComponent.js